export default "__VITE_ASSET__BMAMD4bm__"